import { Calculated } from "../../models/Dilution";

export const getCalculatedValueFieldInput = (value: Calculated | null) =>
  value?.displayedValue ?? "";
